import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
const getTestimonials = (t: any) => [{
  quote: t('test_1_quote'),
  name: 'Sarah Jenkins',
  title: t('test_1_role'),
  company: 'Global Logistics Corp',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: t('test_2_quote'),
  name: 'Michael Chen',
  title: t('test_2_role'),
  company: 'FinTech Solutions',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  quote: t('test_3_quote'),
  name: 'Elena Rodriguez',
  title: t('test_3_role'),
  company: 'Retail Innovations',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=200&h=200'
}];
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = getTestimonials(t);
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-301">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-5 bg-grid-pattern" data-id="element-302" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-303">
        <div className="text-center mb-16" data-id="element-304">
          <motion.h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-305">
            {t('test_title')}
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-306">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 relative hover:bg-white/10 transition-colors" data-id="element-307">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-white/10" data-id="element-308" />

              <div className="flex gap-1 mb-6" data-id="element-309">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-electric text-electric" data-id="element-310" />)}
              </div>

              <p className="text-slate-300 mb-8 leading-relaxed relative z-10" data-id="element-311">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-312">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-electric" data-id="element-313" />
                <div data-id="element-314">
                  <div className="font-bold text-white" data-id="element-315">{testimonial.name}</div>
                  <div className="text-sm text-slate-400" data-id="element-316">
                    {testimonial.title}, {testimonial.company}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}